/**
 * Created by wangjianwen on 2017/10/16.
 */
import * as func from '../function';
export  default{
    setCurrentExamInfo(states, examInfo){
        states.currentExamInfo = {...states.currentExamInfo,...examInfo};
        func.func.set('currentExamInfo',examInfo);
    },
    setBatch(states, batch){
        states.batch = batch;
        func.func.set('batch',batch);
    },
    setApiState(states, api_state){
        states.api_state = api_state;
        func.func.set('api_state',api_state);
    }
}